import { Controller } from "@hotwired/stimulus"

// 顧客 select の選択に応じて、デフォルト会場 select の選択肢を顧客別の会場に切り替える
export default class extends Controller {
  static targets = ["customer", "venue"]
  static values = { venues: Object }

  customerChanged() {
    const customerId = this.customerTarget.value
    const venues = this.venuesValue[customerId] || []
    this.rebuildVenueOptions(venues)
  }

  rebuildVenueOptions(venues) {
    const select = this.venueTarget
    const current = select.value

    select.innerHTML = ""

    const blank = document.createElement("option")
    blank.value = ""
    blank.textContent = "-（未設定）"
    select.appendChild(blank)

    venues.forEach(venue => {
      const option = document.createElement("option")
      option.value = String(venue.id)
      option.textContent = venue.name
      if (String(venue.id) === current) option.selected = true
      select.appendChild(option)
    })
  }
}
